/**
 * 全局配置文件
 */
const config = {
  // 项目code，zstp，产品code，twirls
  projectCode: 'zstp',
  productCode: 'twirls',
  wordDictCode: 'wordDict',
  fitHeight: 1080, // UI设计的适配高度
  systemName: '医疗计算平台', // 系统名称
  footer: 'Copyright © 2021 北京哲源科技有限责任公司出品', // 页脚文字
  loginStorageKey: 'loginInfoService', // 存储在localStorage中的变量名称
  currentPageKey: 'currentPageService', // 当前页信息存储在localStorage中的变量名称
  headerTokenKey: 'Authentication', // 调用后端接口时，header中传递token变量的名称
  apiDomain: {
    'http://localhost:3000': 'http://twirls.cqxyy.org.cn/api',
    'http://mc-twirls.dev.cqxyy.net': 'http://org-arch-gateway.dev.cqxyy.org.cn',
    'http://mc-twirls.test.cqxyy.net': 'http://org-arch-gateway.test.cqxyy.org.cn',
    'http://mc-twirls.demo.cqxyy.org.cn': 'http://org-arch-gateway.dev.cqxyy.org.cn',
    'http://twirls.cqxyy.org.cn': 'http://twirls.cqxyy.org.cn/api',
  }, // 当前域名与后端api地址映射关系
  visualizationApiDomain: { // 3D可视化当前域名与后端api地址映射关系
    'http://localhost:3000': {
      icn3d: 'http://mc-web-icn3d.dev.cqxyy.net',
      jalview: 'http://mc-web-jalview.dev.cqxyy.net',
    },
    'http://mc.dev.cqxyy.net': {
      icn3d: 'http://mc-web-icn3d.dev.cqxyy.net',
      jalview: 'http://mc-web-jalview.dev.cqxyy.net',
    },
    'http://mc.test.cqxyy.net': {
      icn3d: 'http://mc-web-icn3d.test.cqxyy.net',
      jalview: 'http://mc-web-jalview.test.cqxyy.net',
    },
  },
};
export default config;